import React, { useRef, useEffect, useState } from "react";
import { connect } from "react-redux";
import { getFilteredEntry } from "../../../actions/datewisebarcodeentryAction";
import {
    Layout,
    DatePicker,
    Row,
    Col,
    Select,
    Divider,
    AutoComplete,
    Form,
    Button,
} from "antd";
const { Option } = Select;
const { RangePicker } = DatePicker;

const Datewisebarcode = ({
    getFilteredEntry,
    setloading,
    barcodelist,
    reload,
    setreload
}) => {
    const [itreload, setitreload] = useState(false);
    const start = useRef("");
    const end = useRef("");

    useEffect(() => {
        if(start.current != "" && end.current != ""){
        barcodelist.current = []
        setloading(true);
        getFilteredEntry(
            start.current,
            end.current,
        ).then(function (result) {
            if (result.count > 0) {
                for (let i = 0; i < result.results.length; i++) {
                    barcodelist.current.push({
                        variation: result.results[i].ProductLocation,
                        Quantity: result.results[i].quantity,
                    });
                }

                // console.log(barcodelist.current)
                setloading(false);
                setreload(!reload);
            } else {


                setloading(false);
                alert("No data found")
                setreload(!reload);
            }

        });
    }
    }, [itreload]);

    return (
        <>
            <h3>Select a datetime range</h3>
            <RangePicker
                showTime
                style={{ width: "50%" }}
                picker="date"
                onChange={(value) => {
                    if (value) {
                        // start.current = value[0].format("YYYY-MM-DD") + "T00:00:00";
                        // end.current = value[1].format("YYYY-MM-DD") + "T23:59:59";
                        start.current = value[0].format("YYYY-MM-DD")+"T"+value[0].format("HH:mm:ss");
                        end.current = value[1].format("YYYY-MM-DD")+"T"+value[1].format("HH:mm:ss");
                        console.log(value[0]);
                    }
                }}
            />
            <Button type="primary" onClick={() => setitreload(!itreload)}>Search</Button >
        </>
    );
};

export default connect(null, {
    getFilteredEntry,
})(Datewisebarcode);
